import { PDField } from '../../../stores/pdf.store'

export * from './Required'

export type FieldValidationSignature = React.FC<{
  field: PDField
}>
